import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SpinnerType } from '../../../core/model';

@Component({
  selector: 'py-action-button',
  templateUrl: './action-button.component.html',
  styleUrls: ['./action-button.component.scss'],
  standalone: false,
})
export class ActionButtonComponent {
  @Input()
  disabled: boolean;

  @Input()
  loading? = false;

  @Input()
  error? = false;

  @Input()
  success? = false;

  @Input()
  successText?: string;

  @Input()
  ariaLabel?: string;

  @Input()
  buttonLabel: string;

  @Input()
  buttonIcon: string;

  @Input()
  type: 'button' | 'submit' = 'button';

  @Input()
  buttonId: string;

  @Input()
  buttonClass: string = 'btn btn-primary';

  @Input()
  center: boolean;

  @Input()
  spinnerType: SpinnerType = SpinnerType.Default;

  @Output()
  activate = new EventEmitter<void>();

  onClick(): void {
    this.activate.emit();
  }
}
